import { render, staticRenderFns } from "./CaptionJoin.vue?vue&type=template&id=4910b224&scoped=true&"
import script from "./CaptionJoin.vue?vue&type=script&lang=js&"
export * from "./CaptionJoin.vue?vue&type=script&lang=js&"
import style0 from "./CaptionJoin.vue?vue&type=style&index=0&id=4910b224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910b224",
  null
  
)

export default component.exports